import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#EA4335",
			d: "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85A23 23 0 0 0 24 0 24 24 0 0 0 2.56 13.22l7.98 6.19A14.3 14.3 0 0 1 24 9.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4285F4",
			d: "M46.98 24.55q-.02-2.36-.38-4.55H24v9.02h12.94a11.2 11.2 0 0 1-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FBBC05",
			d: "M10.53 28.59q-.74-2.18-.76-4.59c-.02-2.41.27-3.14.76-4.59l-7.98-6.19a23.9 23.9 0 0 0 .01 21.56z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#34A853",
			d: "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6a14.4 14.4 0 0 1-8.16 2.3c-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19A24 24 0 0 0 24 48"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h48v48H0z"
		})
	]
});
export { SvgGoogleLogo as ReactComponent };
